exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner{width:100%;display:flex;justify-content:center}.loading{width:50px;height:50px;border-radius:50%;border:5px solid hsla(0,0%,100%,.3);border-top:5px solid var(--charity-primary);animation:spin 1s ease-in-out infinite;-webkit-animation:spin 1s ease-in-out infinite}@keyframes spin{to{-webkit-transform:rotate(1turn)}}", ""]);

// exports
